<template>
  <div>
    <q-select
      v-if="!required"
      v-model="model"
      use-input
      input-debounce="0"
      :label="label"
      option-label="division_name"
      option-value="id"
      :emit-value="true"
      map-options
      :loading="dataLoading"
      :options="options"
      :clearable="clearable"
      @filter="filterFn"
      @input="$emit('changed', model)"
      v-bind="siteCFG.fields.general"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-grey"> No results </q-item-section>
        </q-item>
      </template>
    </q-select>
    <q-select
      v-else
      v-model="model"
      use-input
      input-debounce="0"
      :label="label"
      option-label="division_name"
      option-value="id"
      :emit-value="true"
      map-options
      :loading="dataLoading"
      :options="options"
      :clearable="clearable"
      @filter="filterFn"
      @input="$emit('changed', model)"
      v-bind="siteCFG.fields.general"
      required
      :rules="[(v) => !!v || `Division is required`]"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-grey"> No results </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    props: {
      id: {
        type: Number,
        default: null,
      },
      customData: {
        default: null,
      },
      label: {
        type: String,
        default: "Assign Division",
      },
      clearable: {
        type: Boolean,
        default: false,
      },
      required: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        siteCFG: "settings/siteCFG",
        data: "divisions/list",
        dataLoading: "divisions/listLoading",
      }),
    },
    watch: {
      id: function () {
        this.init();
      },
      divisions: function () {
        this.init();
      },
      customData: function () {
        this.init();
      },
    },
    data: () => ({
      model: null,
      options: [],
    }),
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.options = JSON.parse(
          JSON.stringify(this.customData ? this.customData : this.data)
        );
        this.model = this.id;
      },
      filterFn(val, update) {
        if (val === "") {
          update(() => {
            this.options = JSON.parse(
              JSON.stringify(this.customData ? this.customData : this.data)
            );
          });
          return;
        } else {
          update(() => {
            const needle = val.toLowerCase();
            let options = this.customData ? this.customData : this.data;
            this.options = options.filter(
              (v) => v.division_name.toLowerCase().indexOf(needle) > -1
            );
          });
        }
      },
    },
  };
</script>
